import React from "react"

// Right-side legend for donut charts: colored dot · truncated label · % · bold value
// Designed to match the reference dashboard's clean look.
const PieLegend = ({ items, formatValue }) => {
  const total = items.reduce((acc, i) => acc + i.value, 0)
  return (
    <ul className="space-y-1.5 max-h-[240px] overflow-y-auto pr-1">
      {items.map(item => {
        const pct = total > 0 ? Math.round((item.value / total) * 100) : 0
        return (
          <li key={item.id} className="flex items-center gap-2 min-w-0 text-[12px]">
            <span
              className="w-2 h-2 rounded-full shrink-0"
              style={{ background: item.color }}
            />
            <span className="text-slate-700 truncate flex-1" title={item.label}>
              {item.label}
            </span>
            <span className="text-slate-400 text-[10.5px] tabular-nums shrink-0 w-9 text-right">
              {pct}%
            </span>
            <span className="text-slate-900 font-semibold tabular-nums shrink-0 min-w-[2.5rem] text-right">
              {formatValue ? formatValue(item.value) : item.value.toLocaleString("fr-FR")}
            </span>
          </li>
        )
      })}
    </ul>
  )
}

export default PieLegend
